// extracted by mini-css-extract-plugin
module.exports = {"zer_width":"Viewads_zer_width__2KxOA","t_row":"Viewads_t_row__1B-6i"};